import { combineReducers } from 'redux';

import deck from './manage-deck';

const rootReducer = combineReducers({
  deck
})

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js